// eslint-disable-next-line import/no-cycle
import {
  WidgetTypeConfig,
  ConfigurationPanelStructureItemEnum,
  FieldsGroup,
  LinkTypeEnum,
  TabItem,
  TemplateParentTypeEnum,
} from '@/types';
// eslint-disable-next-line import/no-cycle
import getInputVariablesFieldConfig from '@/components/template-builder/config/fields/input-variables-config';
// eslint-disable-next-line import/no-cycle
import getLinkFieldConfig from '@/components/template-builder/config/fields/link-config';
import variables from '@/components/template-builder/utils/variables-list';
// V3
// eslint-disable-next-line import/no-cycle
import emailButtonFieldsConfig from '@/components/template-builder/config/templates/email/widgets/widget-button-fields-config';
// eslint-disable-next-line import/no-cycle
import displayButtonFieldsConfig from '@/components/template-builder/config/templates/display/widgets/widget-button-fields-config';
// V4
// eslint-disable-next-line import/no-cycle
import emailButtonFieldsConfigV4 from '@/components/template-builder/config/templates/email-v4/widgets/widget-button-fields-config';
// eslint-disable-next-line import/no-cycle
import displayButtonFieldsConfigV4 from '@/components/template-builder/config/templates/display-v4/widgets/widget-button-fields-config';
// eslint-disable-next-line import/no-cycle
import {
  setAttribute,
  setContent,
  setDataNextStepAttribute,
  setDataSendFormAttribute,
} from '@/components/template-builder/setters';
// eslint-disable-next-line import/no-cycle
import {
  getAttributeByName,
  getContent,
} from '@/components/template-builder/getters';
// eslint-disable-next-line import/no-cycle
import { refreshNextSteps } from '@/composables/template-editor/TemplateEditor';
// eslint-disable-next-line import/no-cycle
import getConditionsAndRepetitionGroup from '@/components/template-builder/config/fields/conditions-repetition-group-helper';
// eslint-disable-next-line import/no-cycle
import {
  isDisplayTemplate,
  isEmailTemplate,
  isEmbedTemplate,
  isPopupTemplate,
} from '../../utils/helpers';

const getWidgetButtonConfig = (templateType: TemplateParentTypeEnum, isV4 = false): WidgetTypeConfig => {
  let fieldItems: FieldsGroup | TabItem = {
    label: '',
    type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
  };

  switch (templateType) {
    case TemplateParentTypeEnum.POPUP:
    case TemplateParentTypeEnum.DISPLAY:
    case TemplateParentTypeEnum.EMBED:
      fieldItems = isV4 ? displayButtonFieldsConfigV4 : displayButtonFieldsConfig;
      break;
    default:
      fieldItems = isV4 ? emailButtonFieldsConfigV4 : emailButtonFieldsConfig;
  }

  const linkOptions = [LinkTypeEnum.WEB_ADDRESS, LinkTypeEnum.EMAIL_ADDRESS, LinkTypeEnum.ANCHOR];

  if (isEmailTemplate(templateType)) {
    linkOptions.push(LinkTypeEnum.TO_NEXT_STEP);
    linkOptions.push(LinkTypeEnum.NONE);
  }

  if (isDisplayTemplate(templateType)) {
    linkOptions.push(LinkTypeEnum.TO_NEXT_STEP);
    linkOptions.push(LinkTypeEnum.SEND_FORM);
    if (isEmbedTemplate(templateType)) linkOptions.push(LinkTypeEnum.NONE);
    if (isPopupTemplate(templateType)) linkOptions.push(LinkTypeEnum.CLOSE_POPIN);
  }

  return {
    tabPanel: {
      label: 'templateBuilder.widgetsHeaders.button',
      items: [
        {
          type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
          label: 'templateBuilder.configs.widgetConfiguration',
          selector: 'body #spm_body #{ID}',
          items: [
            {
              label: 'templateBuilder.fields.buttonText',
              selector: '{SELECTOR}.spm_call_to_action > tbody > tr > th table.button > tbody > tr > th > a, {SELECTOR}.spm_call_to_action > tbody > tr > th table.spm_button > tbody > tr > th > a, {SELECTOR}.spm_display_call_to_action a.spm_button',
              properties: [{ name: 'content', getter: getContent, setters: [setContent] }],
              ...getInputVariablesFieldConfig('Texte du bouton', variables.allVariables, false, true),
            },
            {
              label: 'templateBuilder.fields.link',
              selector: '{SELECTOR}.spm_call_to_action > tbody > tr > th table.button > tbody > tr > th > a, {SELECTOR}.spm_call_to_action > tbody > tr > th table.spm_button > tbody > tr > th > a, {SELECTOR}.spm_display_call_to_action a.spm_button',
              properties: [
                {
                  name: 'href',
                  getter: getAttributeByName,
                  setters: [setAttribute, setDataNextStepAttribute],
                  callbacks: [refreshNextSteps],
                },
                {
                  name: 'data-send-form',
                  getter: getAttributeByName,
                  setters: [setDataSendFormAttribute],
                },
              ],
              ...getLinkFieldConfig(LinkTypeEnum.NONE, linkOptions, variables.allVariables),
            },
          ],
        },
        {
          ...fieldItems,
        },
        getConditionsAndRepetitionGroup('body #spm_body #{ID}'),
      ],
    },
  };
};

export default getWidgetButtonConfig;
